import type { RouteConfig } from 'vue-router'

import * as namesConfiguracion from './nombres/configuracion'
import * as namesMantenimiento from './nombres/mantenimiento'
import * as namesTransacciones from './nombres/transacciones'
import { buildBreadcrumb } from '@/@core/utils/router'
import permisosCajacChica, { RESOURCE_CAJA_CHICA } from '@/auth/permissions/modules/cajaChica'

const { mantenimiento, configuracion, transacciones } = permisosCajacChica

export default [
    /**
     * RUTAS DE MANTENIMIENTO
     */
    {
        path: '/caja-chica/mantenimiento/crear-caja-chica',
        name: namesMantenimiento.ROUTE_CREAR_CAJA_CHICA,
        component: () => import('@pages/cajaChica/mantenimiento/CajaChica.vue'),
        meta: {
            title: 'i18n:caja_chica.subopciones.crear_caja_chica',
            resource: RESOURCE_CAJA_CHICA,
            action: mantenimiento.crearCajaChica,
            breadcrumb: buildBreadcrumb(
                'a:caja_chica.menu_title',
                'a:global.menu.mantenimiento',
                'caja_chica.subopciones.crear_caja_chica'
            ),
        },
    },
    {
        path: '/caja-chica/mantenimiento/crear-tipo-gasto',
        name: namesMantenimiento.ROUTE_CREAR_TIPO_GASTO,
        component: () => import('@pages/cajaChica/mantenimiento/TipoGasto.vue'),
        meta: {
            title: 'i18n:caja_chica.subopciones.crear_tipo_gasto',
            resource: RESOURCE_CAJA_CHICA,
            action: mantenimiento.crearTipoGasto,
            breadcrumb: buildBreadcrumb(
                'a:caja_chica.menu_title',
                'a:global.menu.mantenimiento',
                'caja_chica.subopciones.crear_tipo_gasto'
            ),
        },
    },
    /**
     * RUTAS DE CONFIGURACION
     */
    {
        path: '/caja-chica/configuracion/permiso-aprobar-vale',
        name: namesConfiguracion.ROUTE_PERMISO_APROBAR_VALE,
        component: () => import('@pages/cajaChica/configuracion/PermisoAprobarVale.vue'),
        meta: {
            title: 'i18n:caja_chica.subopciones.permiso_aprobar_vale',
            resource: RESOURCE_CAJA_CHICA,
            action: configuracion.permisoAprobarVale,
            breadcrumb: buildBreadcrumb(
                'a:caja_chica.menu_title',
                'a:global.menu.configuracion',
                'caja_chica.subopciones.permiso_aprobar_vale'
            ),
        },
    },
    /**
     * RUTAS DE TRANSACCIONES
     */
    {
        path: '/caja-chica/transacciones/crear-vale-caja',
        name: namesTransacciones.ROUTE_VALE_CAJA,
        component: () => import('@pages/cajaChica/transacciones/ValeCaja.vue'),
        meta: {
            title: 'i18n:caja_chica.subopciones.vale_caja',
            resource: RESOURCE_CAJA_CHICA,
            action: transacciones.valesCaja.valeCaja,
            breadcrumb: buildBreadcrumb(
                'a:caja_chica.menu_title',
                'a:global.menu.transacciones',
                'caja_chica.subopciones.vale_caja'
            ),
        },
    },
    {
        path: '/caja-chica/transacciones/aprobacion-vale-caja',
        name: namesTransacciones.ROUTE_APROBAR_VALE_CAJA,
        component: () => import('@pages/cajaChica/transacciones/AprobacionValeCaja.vue'),
        meta: {
            title: 'i18n:caja_chica.subopciones.aprobacion_vale_caja',
            resource: RESOURCE_CAJA_CHICA,
            action: transacciones.valesCaja.aprobacionValeCaja,
            breadcrumb: buildBreadcrumb(
                'a:caja_chica.menu_title',
                'a:global.menu.transacciones',
                'caja_chica.subopciones.aprobacion_vale_caja'
            ),
        },
    },
    {
        path: '/caja-chica/transacciones/gestion-reposicion-caja',
        name: namesTransacciones.ROUTE_REPOSICION_CAJA_CHICA,
        component: () => import('@pages/cajaChica/transacciones/Reposicion.vue'),
        meta: {
            title: 'i18n:caja_chica.subopciones.reposicion',
            resource: RESOURCE_CAJA_CHICA,
            action: transacciones.reposicionesCaja.reposicionCaja,
            breadcrumb: buildBreadcrumb(
                'a:caja_chica.menu_title',
                'a:global.menu.transacciones',
                'caja_chica.subopciones.reposicion'
            ),
        },
    },
] as RouteConfig[]
